"use client"

import { clsx } from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import useLocale from "~/hooks/useLocale"
import BreadcrumbLinkClient from "~/components/ui/Breadcrumb/BreadcrumbLink"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"
import { removePaddingY } from "./styles.css"

export type ClientBreadcrumbProps = PropsWithClassName<{
  withoutHome?: boolean
  isTop?: boolean
  removePaddingY?: boolean
  isProductPage?: boolean
}>

function ClientBreadcrumb({ className, children, withoutHome, isTop, isProductPage }: ClientBreadcrumbProps) {
  const t = useTranslate()
  const locale = useLocale()

  return (
    <nav
      data-comp="UI/Breadcrumbs"
      aria-label={t("breadcrumbs")}
      className={clsx(
        className,
        isTop ? css.breadcrumbsTopPage : null,
        css.breadcrumbs,
        sprinkles({ paddingBottom: isProductPage ? 8 : 0 })
      )}
    >
      <div className={clsx(isTop ? null : css.wrapper)}>
        <ol className={clsx(css.list, removePaddingY ? css.removePaddingY : null)}>
          {!withoutHome && (
            <BreadcrumbLinkClient key={`breadcrumb_item_home`} href={`/${locale}`}>
              {t("general_homepage")}
            </BreadcrumbLinkClient>
          )}
          {children}
        </ol>
      </div>
    </nav>
  )
}

export default ClientBreadcrumb
